export const REST_PARAMS = {
    leadID: 'leadid',
    leadJourneyID: 'leadjourneyid',
    userType: 'usertype',
    installerName: 'installerName'
};
